export const GET_ALL_ACCESS_REQUEST = 'GET_ALL_ACCESS_REQUEST'
export const GET_ALL_ACCESS_SUCCESS = 'GET_ALL_ACCESS_SUCCESS'
export const GET_ALL_ACCESS_FAIL = 'GET_ALL_ACCESS_FAIL'
export const GET_ALL_ACCESS_RESET = 'GET_ALL_ACCESS_RESET'
